import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOvhComponent } from './simple-icons-ovh.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOvhComponent ],
    exports:      [ SimpleIconsOvhComponent ],
    bootstrap:    []
})
export class SimpleIconsOvhModule {}
